module.exports = "/_next/static/images/cracker-0842cd166adb7e527aed6a50cab474b8.svg";